import { render, staticRenderFns } from "./uploadNew.vue?vue&type=template&id=66acd87c&"
import script from "./uploadNew.vue?vue&type=script&lang=ts&"
export * from "./uploadNew.vue?vue&type=script&lang=ts&"
import style0 from "./uploadNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports